export default {
  "title": "Ghost Hunter",
  "intro": "Unlock rewards as you hit each contribution milestone. Contribute more for greater prizes!",
  "login": "Log in",
  "logout": "Log Out",
  "howToPlay": "How to Play?",
  "contributeDesc": "Unlock rewards as you hit each contribution milestone. Contribute more for greater prizes!",
  "account": "Account ID",
  "code": "Verification code",
  "sendCode": "Send verification code to in-game mailbox",
  "codeSent": "Verification code sent. Please check your in-game mailbox.",
  "submit": "Confirm",
  "cancel": "Cancel",
  "ok": "OK",
  "rewardConfirm": "Confirm",
  "available": "Rockets Remaining",
  "total": "Total strikes",
  "ghostDefeated": "The ghost has been defeated",
  "globalTitle": "Ghost Defeat Progress",
  "strikeTitle": "Strike",
  "strike": "Fire!!!",
  "strikeRecord": "Fire",
  "taskTitle": "Graveyard Brawl",
  "missionClaimed": "Claimed",
  "missionCompleted": "Available to Claim",
  "missionIncomplete": "Not Achieved",
  "share": "Share",
  "sharing": "Sharing",
  "shareOk": "Share completed",
  "milestoneTitle": "Personal milestones",
  "times": "Times",
  "recordTitle": "Reward History",
  "recordDialogTitle": "Reward History",
  "recordReward": "Reward",
  "recordTime": "Receive Time",
  "refresh": "Refresh",
  "empty": "No data available",
  "receive": "Available to Claim",
  "received": "Claimed",
  "notReady": "Not Achieved",
  "locked": "Locked",
  "unlocked": "Available to Claim",
  "rewardTitle": "Rewards",
  "phase": {
    "not_start": "The event has not started yet.",
    "play": "The event is live",
    "view_only": "The event has ended.",
    "closed": "The page is closed"
  },
  "actTime": {
    "notStart": "The event has not started yet.",
    "ended": "The event has ended.",
    "startCountdown": "Countdown to Start",
    "day": "D"
  },
  "taskCycle": {
    "daily": "Daily Mission",
    "weekly": "Weekly Mission"
  },
  "tasks": {
    "hw_daily_login": "Daily Login",
    "hw_daily_play_any_1": "Play any 1 mode",
    "hw_daily_play_any_3": "Play any 3 mode",
    "hw_daily_mojin_3": "Play the Mystic Raid 3 Time",
    "hw_weekly_share": "Share to Social Media"
  },
  "props": {
    "90301916": "[Avatar Frame] Sugar Bomb",
    "70100101": "Gold Diamond",
    "70100011": "Gold",
    "50108900": "Canorus (3 days)",
    "70100004": "Card Point",
    "80103001": "Rank Protection",
    "10301029": "Scythe-Hellbound (3 days)",
    "80102101": "Golden Diamond Draw Ticket",
    "82101002": "Flower",
    "80202003": "Weapon EXP Card LV3",
    "82101003": "Lollipop",
    "81010999": "Universal Growth Coin",
    "70100013": "Mystic Voucher",
    "70100014": "Mystic Key",
    "10101086": "AK15-Rushou"
  },
  "footer": {
    "privacyPolicy": "Privacy Policy",
    "userAgreement": "User Agreement",
    "customerService": "Please contact us via email at ministarcustomerservice{'@'}gmail.com"
  },
  "error": {
    "code401": "Login Expired",
    "code1001": "Invalid parameters",
    "code1004": "Please try again later",
    "code2001": "The event has not started yet.",
    "code2002": "The event has ended.",
    "code2003": "The page is closed.",
    "code2201": "Task not completed",
    "code2202": "Reward already claimed",
    "code2203": "Task is not configured",
    "code2301": "No strikes available",
    "code2401": "This node has not been unlocked yet.",
    "code2402": "Reward already claimed",
    "code2403": "Stage not found",
    "code2501": "Conditions Not Met",
    "code2502": "Already Claimed",
    "code2503": "Milestone not found",
    "code2801": "Reward already claimed",
    "code429": "Too many requests"
  },
  "howToPlayBody": "🎃 [Ghost Hunter] {'|'} Team Up to Defeat the Giant Ghost\n\nOn Halloween night, a giant ghost has stormed into the world of Mini World Royale — fangs bared, claws out, wreaking havoc across the server! Tom Captain, Nonana, Lingyu, and the Starry Mecha are calling all Sharpshooters to arms — rally your firepower, fire cannon after cannon, and blast down the ghost's HP bar layer by layer. Team up to defeat this giant ghost and defend Halloween night!\n\n📅 Event Schedule\nParticipation Period: Oct 23 – Nov 8\nReward Claim/Redemption: Event start – Nov 16\n※ Please claim your rewards within the claim period — unclaimed rewards will be forfeited.\n\n🔥 How to Play: 3 Steps to Defeat the Giant Ghost\n\nStep 1: Get Rockets\nEnter [Graveyard Brawl] and complete Daily/Weekly Quests to earn rocket and Fire!\n\nStep 2: Fire! Blast the Giant Ghost\nTap [FIRE!!!] to attack the giant ghost! Every shot instantly reduces the ghost's server-wide HP and adds to your personal strike contribution. Team up with hunters across the server to blast the ghost's HP bar all the way down! (Unused rockets carry over to the next day — nothing goes to waste.)\n\nStep 3: Unlock Rewards\nServer Rewards: Every time the server's HP bar drops to 25% / 50% / 75% / 100%, all Sharpshooters who took part unlock the matching stage reward! Once the HP bar is fully cleared and the giant ghost is defeated, everyone shares the grand final prize!\nPersonal Rewards: Your own cumulative strike contribution also unlocks [Personal Milestones] — the more you strike, the more you earn!\n\n🏆 My Records\nAll your strikes and claimed rewards can be viewed in [Reward History].",
  "shareTitle": "Trick or treat!!!",
  "shareContent": "Halloween night has arrived — defeat the ghost, share in server-wide grand prizes.\nDon't let your rewards slip away.",
  "accountPlaceholder": "Please enter account",
  "codePlaceholder": "Please enter the verification code."
}
